// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2jttC","label":"Completed_label__3UXIv"};